(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
if (!customElements.get('s-store-page-banner')) {
  customElements.define(
    's-store-page-banner',
    class SectionStorePageBanner extends HTMLElement {
      connectedCallback() {
        this.covers1 = this.querySelectorAll('.store-page-image-1');
        this.covers2 = this.querySelectorAll('.store-page-image-2');
        this.covers3 = this.querySelectorAll('.store-page-image-3');

        if (!this.covers1.length && !this.covers2.length && !this.covers3.length) return;

        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleScroll, { passive: true });
        this.handleScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleScroll);
        this.resetTransforms();
      }

      handleScroll = () => {
        const scrollOffset = Math.max(0, -this.getBoundingClientRect().top);

        this.covers1.forEach((el) => {
          el.style.transform = `rotate(-4.633deg) translateY(${0.3 * scrollOffset}px)`;
        });

        this.covers2.forEach((el) => {
          el.style.transform = `rotate(-10.013deg) translateY(${0.4 * scrollOffset}px)`;
        });

        this.covers3.forEach((el) => {
          el.style.transform = `rotate(14.263deg) translateY(${0.5 * scrollOffset}px)`;
        });
      };

      resetTransforms() {
        this.covers1?.forEach((el) => {
          el.style.transform = 'rotate(-4.633deg)';
        });

        this.covers2?.forEach((el) => {
          el.style.transform = 'rotate(-10.013deg)';
        });

        this.covers3?.forEach((el) => {
          el.style.transform = 'rotate(14.263deg)';
        });
      }
    }
  );
}

},{}]},{},[1])

